import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { nextTick } from 'process';
import { extractDigitsInfo, isNullOrEmpty } from '../../../core/utils';
import { BaseComponent } from '../../../shared/components/base.component';
interface DigitInfo {
  minInt: number;
  minFraction: number;
  maxFraction: number;
}
/**
 * 數字輸入元件
 */
@Component({
  selector: 'sigv-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.scss'],
})
export class InputNumberComponent extends BaseComponent implements OnInit {
  /** 如有設定則會顯示於 formValidate時的錯誤訊息 */
  @Input() fieldName?: string;
  /**輸入是否靠右 */
  @Input() isInputRight = false;
  /** formControl物件
   * @description useForm.controls['externalName']
   */
  @Input() bindingFormControl?: AbstractControl | any;
  /** 空值欲設提示 */
  @Input() placeholder?: string;
  /** 欄位寬度 */
  @Input() maxlength: number = NaN;
  /** 數字最大長度 */
  @Input() maxNumberlength: number;
  /** 頁面是否純檢視*/
  @Input() isReadOnly: boolean = false;
  /**
   * 小數最小位數
   */
  @Input() minFractionDigits?: number;

  /**
   * 小數最大位數
   */
  @Input() maxFractionDigits?: number;

  /**
   * 只顯示整數
   */
  @Input() numberOnly = true;

  /**
   * 允許負數
   */
  @Input() allowNegative = false;

  /**
   * 進位方式
   * 註:off - 四捨五入; up: 無條件進位; down: 無條件捨去
   */
  @Input() round?: string;

  /**
   * 可接受最小值 (inputId可一併設成minmax)
   */
  @Input() min!: number;

  /**
   * 可接受最大值 (inputId可一併設成minmax)
   */
  @Input() max!: number;

  /**
   * 數字顯示格式
   */
  @Input() inputId?:
    | 'integeronly'
    | 'withoutgrouping'
    | 'minmaxfraction'
    | 'minmax' = 'minmaxfraction';

  /**
   * 進位單位
   */
  @Input() step: number = -1;
  /**blur事件 */
  @Output() blur: EventEmitter<any> = new EventEmitter();
  useWidth = '';
  @Input() useGrouping = false;
  digitInfo = {} as DigitInfo;
  useDecimalSetting = globalThis.sigv.appContext.envConfig.format.decimal;
  isInteger = false;
  constructor(private injector: Injector) {
    super(injector);
    //this.digitInfo = extractDigitsInfo(this.useDecimalSetting);
    this.maxNumberlength =
      globalThis.sigv.appContext.envConfig.format.numberMaxLength -
      (Number(this.digitInfo.maxFraction) == 0
        ? 2
        : Number(this.digitInfo.maxFraction));
    //this.minFractionDigits = this.digitInfo.minFraction ?? 2;
    //this.maxFractionDigits = this.digitInfo.maxFraction ?? 2;
    this.digitInfo = extractDigitsInfo(this.useDecimalSetting);
    if (isNullOrEmpty(this.minFractionDigits)) {
      this.minFractionDigits = this.isInteger
        ? 0
        : this.digitInfo.minFraction ?? 2;
    }
    if (isNullOrEmpty(this.maxFractionDigits)) {
      this.maxFractionDigits = this.isInteger
        ? 0
        : this.digitInfo.maxFraction ?? 2;
    }
    this.logger.info({
      minFractionDigits: this.minFractionDigits,
      maxFractionDigits: this.maxFractionDigits,
      digitInfo: this.digitInfo,
    });

    this.useWidth = `${this.maxlength}px`;
    if (this.numberOnly) this.inputId = 'integeronly';
    if (this.inputId !== 'withoutgrouping') this.useGrouping = true;
  }
  render = true;
  forceRender() {
    this.render = false;
    nextTick(() => {
      this.render = true;
    });
  }
  blurEvent(event: any) {
    this.blur.emit(event);
  }
  ngOnInit() {
    this.logger.debug(
      'input-text init',
      ' bindingFormControl:',
      this.bindingFormControl,
      this.minFractionDigits,
      this.maxFractionDigits
    );
    this.useWidth = `${String(this.maxlength)}px`;
    if (
      Number.isInteger(this.minFractionDigits) &&
      Number.isInteger(this.maxFractionDigits)
    ) {
      this.useDecimalSetting = `1.${this.minFractionDigits}-${this.maxFractionDigits}`;
    }
    if (this.minFractionDigits == 0 || this.maxFractionDigits == 0) {
      this.useDecimalSetting = '1.0-0';
      this.minFractionDigits = 0;
      this.maxFractionDigits = 0;
      this.isInteger = true;
    }

    if (this.inputId === 'withoutgrouping') this.useGrouping = false;
  }
}
